define("shared/utils/plans-data/highlights-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class highlightsMapUtil
   * @extends Utils
   */

  /**
   * Stores highlights in callback functions accessible by plan type
   *
   * @method highlightsMap
   * @param {Service} intl
   * @param {Service} locale
   *
   * @returns {Object} Highlights per plan type
   */
  const highlightsMap = (intl, locale) => ({
    free: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('plans.free.highlights.highlight_4'), intl.t('plans.free.highlights.highlight_5')]
    }),
    basics: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('plans.basics.highlights.highlight_4'), intl.t('plans.highlight_mappings.limited_tags', {
        count: plan.numberOfCollectTags
      }), intl.t('plans.basics.highlights.highlight_5'), intl.t('plans.highlight_mappings.limited_hashtag_suggestions', {
        count: plan.numberOfHashtagSearches
      })],
      reactivationHighlights: [intl.t('plans.highlight_mappings.multi_photo'), intl.t('plans.highlight_mappings.tagging'), intl.t('plans.highlight_mappings.limited_tags', {
        count: plan.numberOfCollectTags
      }), intl.t('plans.highlight_mappings.limited_hashtag_suggestions', {
        count: plan.numberOfHashtagSearches
      })]
    }),
    starter: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.schedule_stories'), intl.t('plans.highlight_mappings.video_uploads', {
        amount: plan.videoSizeLimit
      }), intl.t('plans.starter.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('shared_phrases.hashtag_suggestions'), intl.t('shared_phrases.multi_photo_auto_publish'), intl.t('plans.highlight_mappings.auto_publish_reels'), intl.t('plans.highlight_mappings.linkinbio_standard')],
      migrationHighlights: [intl.t('shared_phrases.one_social_set'), intl.t('plans.highlight_mappings.posts_per_profile', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.migrate.new.starter.feature_4')],
      reactivationHighlights: [intl.t('plans.highlight_mappings.stories'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.highlight_mappings.first_comment'), intl.t('plans.highlight_mappings.hashtag_suggestions')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.starter.features_header'),
        includes: [intl.t('authorization.sign_up_trial.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.starter.list.stories_schedule'), intl.t('authorization.sign_up_trial.starter.list.reels_autopublish'), intl.t('authorization.sign_up_trial.starter.list.multi_autopublish'), intl.t('authorization.sign_up_trial.starter.list.bttp'), intl.t('authorization.sign_up_trial.starter.list.unlimited_hashtags', {
          count: plan.hasLimitedHashtagSearches ? plan.numberOfHashtagSearches : intl.t('plans.feature_mappings.unlimited')
        }), intl.t('authorization.sign_up_trial.starter.list.linkinbio'), intl.t('authorization.sign_up_trial.starter.list.analytics')],
        mobile: {
          includes: [intl.t('shared_phrases.social_sets.count', {
            count: plan.numberOfSocialSets
          }), intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
            count: plan.numberOfPosts
          }), intl.t('shared_phrases.users.count', {
            count: plan.numberOfUsers
          })]
        }
      }
    }),
    creator: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.schedule_stories'), intl.t('plans.highlight_mappings.video_uploads', {
        amount: plan.videoSizeLimit
      }), intl.t('plans.starter.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('shared_phrases.hashtag_suggestions'), intl.t('shared_phrases.multi_photo_auto_publish')],
      migrationHighlights: [intl.t('shared_phrases.one_social_set'), intl.t('plans.highlight_mappings.posts_per_profile', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.migrate.new.starter.feature_4')],
      reactivationHighlights: [intl.t('plans.media_kit'), intl.t('shared_words.campaigns'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.highlight_mappings.linkinbio_standard')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.starter.features_header'),
        includes: [intl.t('authorization.sign_up_trial.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.starter.list.stories_schedule'), intl.t('authorization.sign_up_trial.starter.list.reels_autopublish'), intl.t('authorization.sign_up_trial.starter.list.multi_autopublish'), intl.t('authorization.sign_up_trial.starter.list.bttp'), intl.t('authorization.sign_up_trial.starter.list.unlimited_hashtags', {
          count: plan.hasLimitedHashtagSearches ? plan.numberOfHashtagSearches : intl.t('plans.feature_mappings.unlimited')
        }), intl.t('authorization.sign_up_trial.starter.list.linkinbio'), intl.t('authorization.sign_up_trial.starter.list.analytics')]
      }
    }),
    growth: plan => {
      var _locale$formatCurrenc, _locale$formatCurrenc2, _locale$formatCurrenc3;

      return {
        highlights: [intl.t('plans.highlight_mappings.social_sets_extra', {
          count: plan.numberOfSocialSets,
          amount: (_locale$formatCurrenc = locale.formatCurrency(plan.additionalSocialSetCosts.monthly.dollars)) === null || _locale$formatCurrenc === void 0 ? void 0 : _locale$formatCurrenc.replace('.00', '')
        }), intl.t('plans.highlight_mappings.users_with_extra', {
          count: plan.numberOfUsers,
          amount: (_locale$formatCurrenc2 = locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)) === null || _locale$formatCurrenc2 === void 0 ? void 0 : _locale$formatCurrenc2.replace('.00', '')
        }), intl.t('plans.highlight_mappings.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('shared_phrases.schedule_stories'), intl.t('shared_phrases.linkinbio_standard'), intl.t('plans.growth.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('plans.growth.highlights.highlight_8'), intl.t('shared_phrases.multi_photo_auto_publish'), intl.t('shared_phrases.instagram_product_tags')],
        migrationHighlights: [intl.t('shared_phrases.social_sets.count', {
          count: plan.numberOfSocialSets
        }), intl.t('plans.highlight_mappings.posts_per_profile', {
          count: plan.numberOfPosts
        }), intl.t('plans.highlight_mappings.users_with_extra', {
          count: plan.numberOfUsers,
          amount: (_locale$formatCurrenc3 = locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)) === null || _locale$formatCurrenc3 === void 0 ? void 0 : _locale$formatCurrenc3.replace('.00', '')
        })],
        reactivationHighlights: [intl.t('plans.highlight_mappings.stories'), intl.t('plans.highlight_mappings.linkinbio_standard'), intl.t('plans.highlight_mappings.analytics_standard'), intl.t('plans.highlight_mappings.first_comment'), intl.t('plans.highlight_mappings.collect')],
        trialOptInHighlights: {
          featuresHeader: intl.t('authorization.sign_up_trial.growth.features_header'),
          includes: [intl.t('authorization.sign_up_trial.posts_per_month', {
            count: plan.numberOfPosts
          }), intl.t('shared_phrases.users.count', {
            count: plan.numberOfUsers
          })],
          keyFeatures: [intl.t('authorization.sign_up_trial.growth.list.analytics'), intl.t('authorization.sign_up_trial.growth.list.shopify'), intl.t('authorization.sign_up_trial.growth.list.linkinbio', {
            count: plan.numOfLinkinbioLinkedSocialPosts
          }), intl.t('authorization.sign_up_trial.growth.list.collect'), intl.t('authorization.sign_up_trial.growth.list.brand_management')],
          mobile: {
            includes: [intl.t('shared_phrases.social_sets.count', {
              count: plan.numberOfSocialSets
            }), intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
              count: plan.numberOfPosts
            }), intl.t('shared_phrases.users.count', {
              count: plan.numberOfUsers
            })]
          }
        }
      };
    },
    advanced: plan => {
      var _locale$formatCurrenc4, _locale$formatCurrenc5, _locale$formatCurrenc6;

      return {
        highlights: [intl.t('plans.highlight_mappings.social_sets_extra', {
          count: plan.numberOfSocialSets,
          amount: (_locale$formatCurrenc4 = locale.formatCurrency(plan.additionalSocialSetCosts.monthly.dollars)) === null || _locale$formatCurrenc4 === void 0 ? void 0 : _locale$formatCurrenc4.replace('.00', '')
        }), intl.t('plans.highlight_mappings.users_with_extra', {
          count: plan.numberOfUsers,
          amount: (_locale$formatCurrenc5 = locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)) === null || _locale$formatCurrenc5 === void 0 ? void 0 : _locale$formatCurrenc5.replace('.00', '')
        }), intl.t('shared_phrases.unlimited_posts'), intl.t('shared_phrases.schedule_stories'), intl.t('shared_phrases.linkinbio_standard'), intl.t('plans.advanced.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('plans.advanced.highlights.highlight_8')],
        migrationHighlights: [intl.t('plans.advanced.highlights.highlight_1'), intl.t('shared_phrases.unlimited_posts'), intl.t('plans.highlight_mappings.users_with_extra', {
          count: plan.numberOfUsers,
          amount: (_locale$formatCurrenc6 = locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)) === null || _locale$formatCurrenc6 === void 0 ? void 0 : _locale$formatCurrenc6.replace('.00', '')
        })],
        reactivationHighlights: [intl.t('plans.highlight_mappings.stories'), intl.t('plans.highlight_mappings.linkinbio_standard'), intl.t('plans.highlight_mappings.analytics_standard'), intl.t('plans.highlight_mappings.first_comment'), intl.t('plans.highlight_mappings.collect')],
        trialOptInHighlights: {
          featuresHeader: intl.t('authorization.sign_up_trial.advanced.features_header'),
          includes: [intl.t('authorization.sign_up_trial.advanced.unlimited_posts'), intl.t('shared_phrases.users.count', {
            count: plan.numberOfUsers
          })],
          keyFeatures: [intl.t('authorization.sign_up_trial.advanced.list.live_chat')]
        }
      };
    }
  });

  var _default = highlightsMap;
  _exports.default = _default;
});